import React from 'react';

import { Text } from '@atlaskit/primitives/compiled/text';

interface BoldMatchingTextProps {
	match: string;
	children: string;
	isSmall?: boolean;
}

export const BoldMatchingText = ({
	match,
	children,
	isSmall = false,
}: BoldMatchingTextProps): React.JSX.Element => {
	if (match === '') {
		return <>{children}</>;
	}

	// Escape special characters to avoid getting them interpreted in the RegExp group
	const escapedSpecialCharsInMatchQuery = match.replace(/[\\.,*+?^${}()|[\]]/g, '\\$&');
	const parts = children.split(new RegExp(`(${escapedSpecialCharsInMatchQuery})`, 'gi'));
	return (
		<>
			{parts.map((part) => {
				if (part.toLowerCase() === match.toLowerCase()) {
					return (
						<Text
							testId="custom-select-option.bold-text"
							as="strong"
							size={isSmall ? 'small' : undefined}
						>
							{part}
						</Text>
					);
				}
				return <>{part}</>;
			})}
		</>
	);
};
